export default function MemberActivity() {
  const stats = [
    { icon: 'ri-user-add-line', label: '今日新增会员', value: '186' },
    { icon: 'ri-edit-line', label: '今日新帖', value: '423' },
    { icon: 'ri-chat-3-line', label: '今日回复', value: '2,568' },
    { icon: 'ri-user-heart-line', label: '在线人数', value: '3,892' },
  ];

  return (
    <section className="bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            社区动态
          </h2>
          <p className="text-sm text-foreground-600 mt-1">实时了解社区活跃情况</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                <i className={`${stat.icon} text-lg`}></i>
              </div>
              <div className="text-2xl font-bold text-foreground-900">{stat.value}</div>
              <div className="text-sm text-foreground-600 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}